import service from '@/store/services/settings/exam-cycle-service';

const state = {
    list: {},
    examCycle: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, examCycle) => {
        state.examCycle = examCycle;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(examCycle => {
                commit('SET_RESOURCE', examCycle);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(examCycle => {
                commit('SET_RESOURCE', examCycle);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((examCycle) => {
                commit('SET_RESOURCE', examCycle);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((examCycle) => {
                commit('SET_RESOURCE', examCycle);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    examCycle: state => state.examCycle,
    dropdown: (state) => {
        return state.list.map(examCycle => ({
            id: examCycle.id,
        }));
    }
};

const examCycles = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default examCycles;
